import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

export const SubHeading = ({ children }: PropsWithChildren) => (
    <p css={subheadingCss}>{children}</p>
);

const subheadingCss = css({
    margin: "8px 0 16px",
    textAlign: "center"
});
